import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://onecarelife.health";
const DEFAULT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/114e22c2-b272-445b-b188-ff1dceeb5e07/images/bf36040e8f4e7217c415fffbe3c26b07e90703f90350c9a2dda86101c38aeaaa.jpeg";

export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${SITE_URL}${path}`} />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={image} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
  </Helmet>
);
